import React, { useEffect, useState } from 'react';
import { Row, Col, Table, message } from 'antd';
import axios from 'axios';
import FileConstants from '../../../../FileConstants';
import ENVIRONMENT from '../../../../environments';
import DottedLoader from '../../DottedLoader';
import * as Utilities from '../../Utilities';


export default function InAppPurchasesDetails() {

    const [inAppPurchasesDetails, setInAppPurchasesDetails] = useState([]);
    const [loader, setLoader] = useState(true);

    const getColumns = () => {
        return [
            {
                title: <span className="manrope f-14 black-14">Request Type</span>,
                dataIndex: 'request_type',
                key: 'request_type',
                render: (text) => (
                    <span className="manrope f-12 black-14">{FileConstants.setRequestTypeText(text)}</span>),
            },
            {
                title: <span className="manrope f-14 black-14">Requested On</span>,
                dataIndex: 'request_time',
                key: 'request_time',
                render: text => <span className="manrope f-12 black-14">{Utilities.convertUtcToLocalTimezone(text)}</span>,
                // sorter: (a, b) => new Date(a.request_time) - new Date(b.request_time),
            },
            {
                title: <span className="manrope f-14 black-14">Amount</span>,
                dataIndex: 'amount',
                key: 'amount',
                render: text => <span className="manrope f-12 green w-600">${text / 100}</span>,
            },
            {
                title: <span className="manrope f-14 black-14">Receipt</span>,
                dataIndex: 'receipt_url',
                key: 'receipt_url',
                render: text => <a className="manrope f-12" href={text} target="_blank">
                    View Receipt
                </a>,
            },


        ].filter(col => !col.hidden);
    }


    useEffect(() => {

        let payload = {
            'customer_username': FileConstants.CUSTOMER_USERNAME
        }

        axios.post(ENVIRONMENT.GET_IN_APP_AVAILED_ENTITIES, payload)
            .then(res => {
                if (res && res['data']) {
                    console.log(res['data'])
                    if (res['data'].length > 0) {
                        let data = res['data'].sort((a, b) => b.transaction_id - a.transaction_id);
                        setInAppPurchasesDetails(data);
                    }
                    
                    setLoader(false);
                }
            })
            .catch(error => {
                console.log('ERROR = ', error)
                message.error('Something went wrong. Please try again.')
            })
    }, [])

    return (
        <>
            {loader && inAppPurchasesDetails.length == 0 ? (
                <DottedLoader />
            ) : (
                <Row>
                    <Col span={24}>
                        <Table
                            tableLayout='fixed'
                            columns={getColumns()}
                            dataSource={inAppPurchasesDetails} />
                    </Col>
                </Row>
            )}
        </>
    )
}